export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  statusToTrack: "FAILED_CHECKOUT",

  paymentMethod() {
    return primerTranslations.payment_methods[this.store.values.paymentMethod || "default"]
  },

  retry() {
    window.location = this.store.addTokenHashParam(nextStepPath)
  },
})
